'use client'
import { Link } from "@/locales/routing"
import { cn } from "@heroui/theme"
import { useTranslations } from "next-intl"
import { useClosePricing } from "."

/** 购买弹窗里的兑换码入口：跳 /redeem 并关掉弹窗（在 /pricing 页里关弹窗是空操作） */
export default function RedeemEntry({ className }: { className?: string }) {
  const t = useTranslations('redeem')
  const closePricing = useClosePricing()

  return (
    <p className={cn("text-center text-[12px] text-theme-primary/50", className)}>
      {t('haveCode')}{' '}
      <Link
        href="/redeem"
        prefetch={false}
        onClick={closePricing}
        className="font-bold text-theme-primary/80 underline underline-offset-4 hover:text-theme-primary"
      >
        {t('entry')}
      </Link>
    </p>
  )
}
